import * as React from "react";
import { I18n } from "react-redux-i18n";
import { FormControl } from "@common/components/form-control";

import { getTestAttributes } from "@common/utils/tests";
import { Flex } from "@common/components/Flex";
import { PedigreeSelector } from "@common/components/pedigree-selector";
import { TreeGetIdArgs } from "@common/components/Tree/tree.types";
import { PedigreeGetDto } from "@common/dto/pedigree/get-dto";
import { FolderListDto } from "@common/dto/folder/list-dto";
import { getFolders } from "@common/actions/folders";

import { getPedigrees } from "@modules/individuals/actions/pedigrees";
import { individualSearch } from "@modules/individuals/actions/individuals";

import "./move-to-existing-pedigree.styles.scss";

type MoveToExistingPedigreeProps = {
  showErrorMessage: (message?: string) => void;
  selectedPedigree?: PedigreeGetDto;
  onPedigreeSelect: (data: {
    folder?: FolderListDto;
    pedigree: PedigreeGetDto;
  }) => void;
};

export const MoveToExistingPedigree = (props: MoveToExistingPedigreeProps) => {
  const [isOpenedPedigreeSelector, setOpenedPedigreeSelector] = React.useState(false);

  const getFieldSelectorFieldId = React.useCallback(
    (pedigree: PedigreeGetDto, rowIndex: number) => `grid-${rowIndex}-0`,
    []
  );

  const getFieldSelectorFolderId = React.useCallback(
    ({ parentIndex, ownIndex }: TreeGetIdArgs) =>
      `tree-root-child${parentIndex || 0}-child${ownIndex}-content`,
    []
  );

  const openFieldSelector = React.useCallback(
    () => setOpenedPedigreeSelector(true),
    []
  );

  const closePedigreeSelector = React.useCallback(
    () => setOpenedPedigreeSelector(false),
    []
  );

  const handlePedigreeSelect = React.useCallback((data: {
    folder?: FolderListDto;
    pedigree: PedigreeGetDto;
  }) => {
    closePedigreeSelector();
    props.onPedigreeSelect(data);
  }, [closePedigreeSelector, props.onPedigreeSelect]);
  
  const individualsContext = 1;

  return (
    <div className="MoveToExistingPedigree">
      <Flex alignItems="center" className="MoveToExistingPedigree__field">
        <label
          className="MoveToExistingPedigree__name__label"
          {...getTestAttributes({ id: "ped-name-lbl" })}
        >
          {I18n.t("Pedigree Name")}:
        </label>
        <div
          {...getTestAttributes({
            id: "ind-move-new-ped-wnd-ind-dd-renderer-tx",
          })}
          className="MoveToExistingPedigree__name__input"
        >
          <FormControl
            value={props.selectedPedigree?.name || ""}
            {...getTestAttributes({
              id: "ind-move-exist-ped-wnd-ped-name",
            })}
            onClick={openFieldSelector}
            onChange={openFieldSelector}
          />
        </div>
      </Flex>
      {isOpenedPedigreeSelector && (
        <PedigreeSelector
          withSearch
          getId={{
            search: "search-box-tx",
            searchIcon: "search-box-icon",
            title: "lbl-ambry-whs-header",
            cancelBtn: "btn-ambry-whs-cancel",
            submitBtn: "btn-ambry-whs-add",
            field: getFieldSelectorFieldId,
            folder: getFieldSelectorFolderId,
          }}
          getFolders={() => getFolders({ context: individualsContext })}
          getPedigrees={getPedigrees}
          individualSearch={individualSearch}
          onSubmit={handlePedigreeSelect}
          onClose={closePedigreeSelector}
          showErrorMessage={props.showErrorMessage}
        />
      )}
    </div>
  );
};
